/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        name: "搜索",
        type: "module-name"
    },
    {
        key: "style_type",
        name: "样式",
        type: "radio-box-img",
        width: 270,
        "radio-list": [{
                url: "https://img.mockuai.com/tms/2018/1/9/upload_6a651979ea2db50244524e994c618188.png",
                value: 1
            },
            {
                url: "https://img.mockuai.com/tms/2018/1/9/upload_5014bc96ffa3e6f1cdf899f21c6b0af0.png",
                value: 2
            }
        ]
    },
    {
        key: "property_data",
        name: "属性",
        type: "custom",
        content: [{
                key: "background_color",
                name: "背景颜色",
                type: "color"
            },
            {
                key: "input_background_color",
                name: "内框颜色",
                type: "color"
            },
            {
                key: "search_hint",
                name: "快速搜索",
                type: "text"
            },
            {
                key: "search_scope",
                name: "搜索范围",
                type: "radio-box",
                "radio-list": [{
                        label: "商品",
                        value: 1
                    },
                    {
                        label: "服务",
                        value: 2
                    },
                    {
                        label: "店铺",
                        value: 3
                    },
                    {
                        label: "资讯",
                        value: 4
                    }
                ]
            }
        ]
    }
];

export default config;